import { createLightTheme, createDarkTheme, BrandVariants } from '@fluentui/react-components';

export const orangeBrand: BrandVariants = {
  10: '#2B3240', 20: '#2B3240', 30: '#2B3240', 40: '#2B3240', 50: '#2B3240',
  60: '#EB9110', 70: '#EB9110', 80: '#EB9110', 90: '#EB9110', 100: '#EB9110',
  110: '#FFD9B3', 120: '#FFE5CC', 130: '#FFF2E0', 140: '#FFF8F0', 150: '#FFFFFF',
  160: '#FFFFFF',
};

export const lightTheme = createLightTheme(orangeBrand);
export const darkTheme = createDarkTheme(orangeBrand);
